import _ from "lodash";
import client from "lib/apolloClient/client";
import { getAttachmentModalityQuery } from "./AIChatQueries";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

export const getAttachmentModality = variables => {
  return async dispatch => {
    try {
      const response = await client.query({
        query: getAttachmentModalityQuery,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      if (e) dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const getAttachmentFromCache = variables => {
  return dispatch => {
    try {
      const response = client.readQuery({
        query: getAttachmentModalityQuery,
        variables,
      });

      return _.get(response, "node", {});
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};
